
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { SubValList } from './subVal/SubValList';
import { EntityPropList } from '../entityProp/EntityPropList';

export const SubDetail = () => {

  const { entityObj } = useEntityMgr();
  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'val', label: 'Results', content: <SubValList parentEntityId={entityObj.id} /> },
    { id: 'prop', label: 'Properties', content: <EntityPropList parentEntity="SUB" parentEntityObj={entityObj}/>},
  ];
  
  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}